export const sortByAddress = (list, order) => {
  if (!Array.isArray(list) || !order) return list;

  const buildAddress = (property) =>
    `${property?.street_number || ""} ${property?.street_name || ""} ${
      property?.city || ""
    }`.toLowerCase();

  const compare = (a, b) => buildAddress(a).localeCompare(buildAddress(b));

  if (order === "a-z") {
    return [...list].sort(compare);
  }

  if (order === "z-a") {
    return [...list].sort((a, b) => compare(b, a));
  }

  return list;
};
